import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Navigation from '../components/Navigation';
import React, { Component } from 'react';
import styles from './css/Header.scss';

export class Header extends Component {
    static propTypes = {
        languages: ImmutablePropTypes.list.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        tenant: ImmutablePropTypes.map.isRequired,
    }

    render() {
        const { languages, session, tenant } = this.props;
        const img = tenant.has('options') ? tenant.get('options')
            .find(opt => opt.get('key') === 'logo_file')
            .get('value') : null;

        return (
            <header className={styles.header} id='page-header'>
                <div className={styles.container}>
                    {img
                        ? (
                            <Link to='/'>
                                <img className={styles.image} src={`/${img}`} alt={tenant.get('name')} />
                            </Link>
                        )
                        : null
                    }
                </div>
                <Navigation languages={languages} session={session} />
            </header>
        );
    }
}

export default connect((state) => ({
    languages: state.languages,
    session: state.session,
    tenant: state.tenant,
}))(Header);
